export const createUniqueId = () => {
  return Math.random().toString(36).substr(2, 9);
};

export const filterOnlyAllowedComponents = (listComponents = [], componentsAllowed) => {
  return listComponents.filter((child) => {
    return componentsAllowed.some((componentConstructor) => child.type === componentConstructor);
  });
};
